// extracted by mini-css-extract-plugin
export default {"monthInput":"ListLibroMayor_monthInput__bSZdZ"};